module.exports = __webpack_public_path__ + "img/space-station-moon-construction.5b0928ab.svg";